import { Component,Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
 
@Component({
  selector: 'app-time-line',
  templateUrl: './time-line.component.html',
  styleUrls: ['./time-line.component.css']
})
export class TimeLineComponent implements OnChanges  {
 @Input() inspectionProcessingTime: Array<any> = [];
  constructor() { } 
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inspectionProcessingTime']) {
      console.log('Timeline data received:', this.inspectionProcessingTime);
    }
  }
}
